const carouselItems = [
  {
    title: '鬼灭之刃 无限城篇',
    tag: '日漫热播',
    desc: '炭治郎与鬼杀队迎来最终决战，无限城篇震撼开幕',
    img: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20demon%20slayer%20style%20illustration%20with%20swordsman%20in%20traditional%20clothing%2C%20dramatic%20lighting%2C%20dark%20background%20with%20fire%20effects%2C%20action%20scene%2C%20warm%20orange%20and%20red%20tones%2C%20cinematic%20composition&width=600&height=400&seq=carousel-01&orientation=landscape',
    badge: '热播中',
    badgeColor: 'bg-primary-500',
  },
  {
    title: '咒术回战 涩谷事变',
    tag: '日漫',
    desc: '五条悟VS两面宿傩，咒术界史上最大战役',
    img: 'https://readdy.ai/api/search-image?query=Anime%20jujutsu%20style%20battle%20scene%20with%20sorcerers%20fighting%2C%20supernatural%20elements%2C%20dark%20urban%20background%2C%20dynamic%20poses%2C%20energy%20effects%2C%20cool%20blue%20and%20white%20contrast%2C%20action%20packed&width=600&height=400&seq=carousel-02&orientation=landscape',
    badge: '热门',
    badgeColor: 'bg-accent-500',
  },
  {
    title: '斗破苍穹 年番',
    tag: '国漫',
    desc: '萧炎突破斗尊境界，中州风云再起，每周持续更新',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20anime%20style%20illustration%2C%20young%20warrior%20with%20flame%20powers%2C%20fantasy%20ancient%20Chinese%20setting%2C%20dramatic%20pose%2C%20golden%20and%20crimson%20color%20palette%2C%20epic%20atmosphere&width=600&height=400&seq=carousel-03&orientation=landscape',
    badge: '更新中',
    badgeColor: 'bg-secondary-500',
  },
  {
    title: '我独自升级 第二季',
    tag: '韩漫改编',
    desc: '成振宇觉醒猎人之路，暗影军团席卷全球',
    img: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20hunter%20with%20dark%20armor%20and%20shadow%20army%2C%20modern%20urban%20fantasy%2C%20cool%20purple%20and%20black%20tones%2C%20powerful%20stance%2C%20dramatic%20lighting&width=600&height=400&seq=carousel-04&orientation=landscape',
    badge: '爆款',
    badgeColor: 'bg-primary-500',
  },
  {
    title: '间谍过家家 第三季',
    tag: '日漫',
    desc: '福杰一家的温馨日常与惊险任务，阿尼亚太可爱了',
    img: 'https://readdy.ai/api/search-image?query=Anime%20spy%20family%20style%20illustration%2C%20cute%20pink%20haired%20girl%20with%20her%20family%2C%20warm%20and%20cozy%20atmosphere%2C%20pastel%20colors%2C%20slice%20of%20life%20and%20action%20mix%2C%20happy%20vibe&width=600&height=400&seq=carousel-05&orientation=landscape',
    badge: '推荐',
    badgeColor: 'bg-accent-500',
  },
  {
    title: '完美世界 年番',
    tag: '国漫',
    desc: '石昊踏足上界，三千道州风云变幻，每周一更',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20anime%20illustration%20of%20young%20cultivator%20in%20ancient%20robes%2C%20celestial%20palace%20background%2C%20mystical%20energy%20surrounding%2C%20golden%20and%20jade%20green%20tones%2C%20epic%20scale&width=600&height=400&seq=carousel-06&orientation=landscape',
    badge: '年番',
    badgeColor: 'bg-secondary-500',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-heading text-foreground-950">焦点专题</h2>
          <p className="mt-3 text-sm text-foreground-600">精选热门动漫专题推荐，发现你的下一部最爱</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <div key={item.title} className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-[3/2] overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 rounded-full text-[10px] font-medium text-background-50 ${item.badgeColor} whitespace-nowrap`}>
                    {item.badge}
                  </span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-[10px] font-medium text-primary-500 bg-primary-100/70 px-2 py-0.5 rounded-full whitespace-nowrap">{item.tag}</span>
                <h3 className="mt-2 text-sm md:text-base font-medium text-foreground-950">{item.title}</h3>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}